<template>
  <div class="container-page-comparables">
    <div class="page-comparables--col">
      <div class="page-comparables--table-comps comparablelist-page-export">
        <table class="comparables_table" aria-describedby="dfdtablecomps">
          <thead>
            <tr>
              <th>
                {{ $t("type") }}
              </th>
              <th>
                {{ $t("valuationFilters.dist") }}
              </th>
              <th>
                {{ $t("assetData.address") }}
              </th>
              <th>
                {{ $t("valuationFilters.sqm") }}
              </th>
              <th>{{ $t("price") }} (€)</th>
              <th>
                {{ $t("marketplace.eur-sqm") }}
              </th>
              <th class="cursor-default">Evo.</th>
              <th>
                <div class="svg-icon-comps">
                  <img :src="bed" class="tableicon" alt="img">
                </div>
              </th>
              <th>
                {{ $t("valuationFilters.on-brains") }}
              </th>
            </tr>
          </thead>
          <tbody id="selectedcomparables_table">
            <tr
              v-for="comparable in comparables.leftCol.selectedcomparables"
              :id="'comparable-' + comparable.iD_comparable"
              :key="comparable.iD_comparable + '_selected'"
              class="selectedrow"
              :class="getComparablesClass(true, comparable)"
            >
              <td><img width="15px" :src="formatterTypology(comparable.c_ID_tipo)" alt="img"></td>
              <td>21</td>
              <td class="comparables_adress">
                <a v-if="comparable.c_categoria === 'Publicados'" :href="comparable.c_link" target="_blank" :title="comparable.c_direccion_completa" @click.stop="">
                  <span v-if="comparable.c_direccion_completa !== ''">{{ comparable.c_direccion_completa }}</span>
                  <span v-else-if="comparable.c_distrito !== ''">{{ comparable.c_distrito }}</span>
                  <span v-else>na</span>
                </a>
                <span v-else-if="comparable.c_direccion_completa !== ''">{{ comparable.c_direccion_completa }}</span>
                <span v-else-if="comparable.c_distrito !== ''">{{ comparable.c_distrito }}</span>
                <span v-else>na</span>
              </td>
              <td>{{ formatterSqm(comparable.c_superficie) }}</td>
              <td>{{ formatterPrice(comparable.c_precio) }}</td>
              <td>{{ formatterEurSqm(comparable.c_eurom2) }}</td>
              <td>
                <span v-if="comparable.c_inc_precio12 < 0"><img :src="down" class="tableicon" width="10" height="11" alt="img"></span>
                <span v-else-if="comparable.c_inc_precio12 > 0"><img :src="up" class="tableicon" width="10" height="11" alt="img"></span>
                <span v-else><img :src="equal" class="tableicon" width="10" height="11" alt="img"></span>
              </td>
              <td>{{ comparable.c_habitaciones }}</td>
              <td class="txt-center">{{ formatterTime(comparable.pubdays) }}</td>
            </tr>
          </tbody>
          <tbody id="comparableslist_table">
            <tr
              v-for="comparable in comparables.leftCol.currentComparables"
              :id="'comparable-' + comparable.iD_comparable"
              :key="comparable.iD_comparable"
              :class="getComparablesClass(false, comparable)"
            >
              <td><img width="15px" :src="formatterTypology(comparable.c_ID_tipo)" alt="img"></td>
              <td>{{ formatterDist(comparable.c_dist) }}</td>
              <td class="comparables_adress">
                <a v-if="comparable.c_categoria === 'Publicados'" :href="comparable.c_link" target="_blank" :title="comparable.c_direccion_completa" @click.stop="">
                  <span v-if="comparable.c_direccion_completa !== ''">{{ comparable.c_direccion_completa }}</span>
                  <span v-else-if="comparable.c_distrito !== ''">{{ comparable.c_distrito }}</span>
                  <span v-else>na</span>
                </a>
                <span v-else-if="comparable.c_direccion_completa !== ''">{{ comparable.c_direccion_completa }}</span>
                <span v-else-if="comparable.c_distrito !== ''">{{ comparable.c_distrito }}</span>
                <span v-else>na</span>
              </td>
              <td>{{ formatterSqm(comparable.c_superficie) }}</td>
              <td>{{ formatterPrice(comparable.c_precio) }}</td>
              <td>{{ formatterEurSqm(comparable.c_eurom2) }}</td>
              <td>
                <span v-if="comparable.c_inc_precio12 < 0"><img :src="down" class="tableicon" width="10" height="11" alt="img"></span>
                <span v-else-if="comparable.c_inc_precio12 > 0"><img :src="up" class="tableicon" width="10" height="11" alt="img"></span>
                <span v-else><img :src="equal" class="tableicon" width="10" height="11" alt="img"></span>
              </td>
              <td>{{ comparable.c_habitaciones }}</td>
              <td class="txt-center">{{ formatterTime(comparable.pubdays) }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="page-comparables--col">
      <div class="page-comparables--table-comps comparablelist-page-export">
        <table class="comparables_table" aria-describedby="compstable2">
          <thead>
            <tr>
              <th>
                {{ $t("type") }}
              </th>
              <th>
                {{ $t("valuationFilters.dist") }}
              </th>
              <th>
                {{ $t("assetData.address") }}
              </th>
              <th>
                {{ $t("valuationFilters.sqm") }}
              </th>
              <th>{{ $t("price") }} (€)</th>
              <th>
                {{ $t("marketplace.eur-sqm") }}
              </th>
              <th class="cursor-default">Evo.</th>
              <th>
                <div class="svg-icon-comps">
                  <img :src="bed" class="tableicon" alt="img">
                </div>
              </th>
              <th>
                {{ $t("valuationFilters.on-brains") }}
              </th>
            </tr>
          </thead>
          <tbody id="selectedcomparables_table">
            <tr
              v-for="comparable in comparables.rightCol.selectedcomparables"
              :id="'comparable-' + comparable.iD_comparable"
              :key="comparable.iD_comparable + '_selected'"
              class="selectedrow"
              :class="getComparablesClass(true, comparable)"
            >
              <td><img width="15px" :src="formatterTypology(comparable.c_ID_tipo)" alt="img"></td>
              <td>21</td>
              <td class="comparables_adress">
                <a v-if="comparable.c_categoria === 'Publicados'" :href="comparable.c_link" target="_blank" :title="comparable.c_direccion_completa" @click.stop="">
                  <span v-if="comparable.c_direccion_completa !== ''">{{ comparable.c_direccion_completa }}</span>
                  <span v-else-if="comparable.c_distrito !== ''">{{ comparable.c_distrito }}</span>
                  <span v-else>na</span>
                </a>
                <span v-else-if="comparable.c_direccion_completa !== ''">{{ comparable.c_direccion_completa }}</span>
                <span v-else-if="comparable.c_distrito !== ''">{{ comparable.c_distrito }}</span>
                <span v-else>na</span>
              </td>
              <td>{{ formatterSqm(comparable.c_superficie) }}</td>
              <td>{{ formatterPrice(comparable.c_precio) }}</td>
              <td>{{ formatterEurSqm(comparable.c_eurom2) }}</td>
              <td>
                <span v-if="comparable.c_inc_precio12 < 0"><img :src="down" class="tableicon" width="10" height="11" alt="img"></span>
                <span v-else-if="comparable.c_inc_precio12 > 0"><img :src="up" class="tableicon" width="10" height="11" alt="img"></span>
                <span v-else><img :src="equal" class="tableicon" width="10" height="11" alt="img"></span>
              </td>
              <td>{{ comparable.c_habitaciones }}</td>
              <td class="txt-center">{{ formatterTime(comparable.pubdays) }}</td>
            </tr>
          </tbody>
          <tbody id="comparableslist_table">
            <tr
              v-for="comparable in comparables.rightCol.currentComparables"
              :id="'comparable-' + comparable.iD_comparable"
              :key="comparable.iD_comparable"
              :class="getComparablesClass(false, comparable)"
            >
              <td><img width="15px" :src="formatterTypology(comparable.c_ID_tipo)" alt="img"></td>
              <td>{{ formatterDist(comparable.c_dist) }}</td>
              <td class="comparables_adress">
                <a v-if="comparable.c_categoria === 'Publicados'" :href="comparable.c_link" target="_blank" :title="comparable.c_direccion_completa" @click.stop="">
                  <span v-if="comparable.c_direccion_completa !== ''">{{ comparable.c_direccion_completa }}</span>
                  <span v-else-if="comparable.c_distrito !== ''">{{ comparable.c_distrito }}</span>
                  <span v-else>na</span>
                </a>
                <span v-else-if="comparable.c_direccion_completa !== ''">{{ comparable.c_direccion_completa }}</span>
                <span v-else-if="comparable.c_distrito !== ''">{{ comparable.c_distrito }}</span>
                <span v-else>na</span>
              </td>
              <td>{{ formatterSqm(comparable.c_superficie) }}</td>
              <td>{{ formatterPrice(comparable.c_precio) }}</td>
              <td>{{ formatterEurSqm(comparable.c_eurom2) }}</td>
              <td>
                <span v-if="comparable.c_inc_precio12 < 0"><img :src="down" class="tableicon" width="10" height="11" alt="img"></span>
                <span v-else-if="comparable.c_inc_precio12 > 0"><img :src="up" class="tableicon" width="10" height="11" alt="img"></span>
                <span v-else><img :src="equal" class="tableicon" width="10" height="11" alt="img"></span>
              </td>
              <td>{{ comparable.c_habitaciones }}</td>
              <td class="txt-center">{{ formatterTime(comparable.pubdays) }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import numeral from 'numeral'
import bed from '@/assets/brains_icons/bed.svg'
import down from '@/assets/brains_icons/down.png'
import up from '@/assets/brains_icons/up.png'
import equal from '@/assets/brains_icons/equal.png'

export default {
  name: 'PageComparablesOthers',
  components: {},
  props: {
    comparables: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      bed: bed,
      down: down,
      up: up,
      equal: equal
    }
  },
  computed: {},
  methods: {
    formatterTypology(idtipo) {
      switch (idtipo) {
        case 0:
          return require('@/assets/brains_icons/residential.png')
        case 1:
          return require('@/assets/brains_icons/flatblack.png')
        case 2:
          return require('@/assets/brains_icons/house.png')
        case 3:
          return require('@/assets/brains_icons/parking.png')
        case 4:
          return require('@/assets/brains_icons/storage.png')
        case 5:
          return require('@/assets/brains_icons/land.png')
        case 6:
          return require('@/assets/brains_icons/retail.png')
        case 7:
          return require('@/assets/brains_icons/office.png')
        case 8:
          return require('@/assets/brains_icons/building.png')
        case 9:
          return require('@/assets/brains_icons/hospitality.png')
        case 10:
          return require('@/assets/brains_icons/industrial.png')
        case 11:
          return require('@/assets/brains_icons/other.png')
        default:
          return require('@/assets/brains_icons/other.png')
      }
    },
    getComparablesClass(selected, comparable) {
      if (selected) {
        return comparable.c_categoria === 'Publicados' ? 'comparable_pub_selected' : 'comparable_nopub_selected'
      }
      return comparable.c_categoria === 'Publicados' ? 'comparable_pub' : 'comparable_nopub'
    },
    formatterDate(itm) {
      return itm !== null ? this.$moment(itm).format('MM/YYYY') : ''
    },
    formatterPrice(itm) {
      return itm !== null ? numeral(Math.ceil(itm)).format('0,0 $') : ''
    },
    formatterEurSqm(itm) {
      return itm !== null ? numeral(Math.ceil(itm)).format('0,0 $') : ''
    },
    formatterDist(itm) {
      return itm !== null ? numeral(Math.ceil(itm)).format('0') : ''
    },
    formatterSqm(itm) {
      return itm !== null ? numeral(Math.ceil(itm)).format('0') : ''
    },
    formatterTime(itm) {
      return itm !== null ? numeral(itm).format('0') + ' d' : ''
    }
  }
}
</script>

<style lang="scss" scoped>
.container-page-comparables {
  width: 100%;
  height: 100%;
  display: grid;

  grid-template-columns: 49% 49%;
  gap: 20px;
  justify-content: space-between;
}

.comparablelist-page-export table {
  width: 100%;
  font-size: 11px;
  border-spacing: 0;

  thead {
    th {
      padding: 4px;
      background-color: white;
      border-bottom: 2px solid #1e3cff;
      font-family: "Montserrat-ExtraBold",sans-serif;
    }

    th:nth-child(1),
    th:nth-child(2),
    th:nth-child(7) {
      text-align: center;
    }

    th:nth-child(4),
    th:nth-child(5),
    th:nth-child(6),
    th:nth-child(8) {
      text-align: right;
    }
  }

  tbody {
    tr {
      height: 12px;
    }

    td {
      height: 12px;
      border-bottom: none;
    }

    td:nth-child(1),
    td:nth-child(2),
    td:nth-child(7) {
      text-align: center;

      img {
        vertical-align: middle;
      }
    }

    td:nth-child(4),
    td:nth-child(5),
    td:nth-child(6),
    td:nth-child(9) {
      text-align: right;
    }

    td:nth-child(8) {
      text-align: center;
    }

    .comparable_pub_selected {
      background-color: rgb(216,175,70);

      &:hover {
        cursor: pointer;
        background-color: rgba(216,175,70, 0.596);
      }
    }

    .comparable_nopub_selected {
      background-color: rgb(194,194,194);

      &:hover {
        background-color: rgba(194,194,194, 0.425);
      }
    }

    .comparable_pub {
      background-color: rgb(232,210,128);

      &:hover {
        cursor: pointer;
        background-color: rgba(232,210,128, 0.548);
      }
    }

    .comparable_nopub {
      background-color: rgb(240,240,240);

      &:hover {
        background-color: rgba(240,240,240, 0.349);
      }
    }
  }

  .comparables_adress {
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    max-width: 130px;

    a {
      text-decoration: underline !important;
    }
  }
}

.comparablelist-page-export {
  height: 100%;
  font-family: "Montserrat-Regular",sans-serif;
}

.svg-icon {
  width: 25px !important;
  height: 15px !important;
  vertical-align: inherit !important;
}

.valuations_subtitle {
  margin-bottom: 3px;
  font-size: 15px;

  .subtitle-1 {
    font-family: "Montserrat-SemiBold",sans-serif;
  }

  .subtitle-2 {
    font-family: "Montserrat-Light",sans-serif !important;
  }

  .valuations_subtitle_small {
    font-weight: normal;
    font-family: "Montserrat-Regular",sans-serif;
    font-size: 0.8em;
  }
}

.svg-icon-comps {
  text-align: center;
}
</style>
